import { useState } from 'react'
//@ts-ignore
import { useTheme } from 'styled-components'
import { useNotification } from 'hooks/use-notification/useNotification'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useFileUpload } from 'hooks/use-file-upload/useFileUpload'
import { UserFeedback } from 'common/types'
import { useFeedApi } from 'hooks/use-feed-api/useFeedApi'

export const useFeedback = () => {
  const theme = useTheme()
  const { notify } = useNotification()
  const { backendUser } = useAuth()
  const [getFeedbackCount, setFeedbackCount] = useState<number>(0)
  const maxFeedbackLength = 1200
  const { getProcessedFile } = useFileUpload()
  const [checked, setChecked] = useState<boolean[]>([false, false])
  const [isValidated, setValidation] = useState(false)
  const [currentFeedback, setCurrentFeedback] = useState<UserFeedback>()
  const [fileName, setFileName] = useState<string>('')
  const { createFeedback } = useFeedApi()

  return {
    theme,
    notify,
    backendUser,
    getFeedbackCount,
    setFeedbackCount,
    maxFeedbackLength,
    getProcessedFile,
    checked,
    setChecked,
    isValidated,
    setValidation,
    currentFeedback,
    setCurrentFeedback,
    fileName,
    setFileName,
    createFeedback
  } as const
}
